import { useEvent } from "js-events-listener/react";
import { useEffect, useState } from "react";
import { fetchMedia, useStyles } from "./Content";

const Document = ({ id, title, session, large }) => {
  const [url, setUrl] = useState("");
  const [err, setErr] = useState(false);
  const [isCowatch, setIsCowatch] = useState(false);
  const [hasControl, setHasControl] = useState(!window.eventTours.lockControl);
  const classes = useStyles({ large });

  useEvent("LOCK_CONTROL", () => setHasControl(false), []);
  useEvent("UNLOCK_CONTROL", () => setHasControl(true), []);

  useEffect(() => {
    if (id) {
      fetchMedia(id)
        .then(data => {
          setUrl(data.public_url);
          if (
            data.public_url.includes(
              "https://theatro360-uploads.s3.eu-west-2.amazonaws.com",
            )
          ) {
            setIsCowatch(true);
          }
        })
        .catch(e => {
          console.error(e);
          setErr(true);
        });
    }
  }, [id, session]);

  if (err) return <div className={classes.error}>Failed to load document</div>;

  return (
    <div className={classes.pdf}>
      <iframe
        src={
          isCowatch
            ? `https://tools.theatro360.com/pdf/${
                url.slice(54).split(".pdf")[0]
              }${
                session
                  ? `/${session}?no_bg=1&force=${hasControl ? 1 : 0}`
                  : "?no_cowatch=1&no_bg=1"
              }`
            : url
        }
        title={title}
        frameBorder="0"
      />
    </div>
  );
};

export default Document;
